/* eslint-disable @typescript-eslint/no-explicit-any */
import { Program } from '@playbook-technologies/common-enums';
import helpers from '../helpers';
import { z } from 'zod';
import { CollectionProgram } from './collections.types';

const ProgramSchema = z.object({
  // NOTE: incomplete as other validation used for more basic fields
  faqs: z
    .array(
      z.object({
        answer: z.string().nonempty({ message: 'This field is required' }),
        question: z.string().nonempty({ message: 'This field is required' }),
      }),
    )
    .nullable()
    .optional(),
  testimonials: z
    .array(
      z.object({
        name: z.string().nonempty({ message: 'This field is required' }),
        text: z.string().nonempty({ message: 'This field is required' }),
        media: z
          .object({
            image: z.string(),
            cdn01: z.string(),
          })
          .nullable()
          .optional(),
      }),
    )
    .nullable()
    .optional(),
});

export const validateCollection = (collection, creationMode) =>
  collection.type === Program.Type.Program.value
    ? validateProgram(collection, creationMode)
    : validateCategory(collection, creationMode);

export const validateCategory = (collection, creationMode: boolean) => {
  const tree = {
    name: helpers.validateString(collection.name, true)
      ? null
      : 'Category title is required.',
    color: helpers.validateString(collection.color, !creationMode)
      ? null
      : 'Color is required.',
    mediaCover: helpers.validateObject(
      collection.mediaCover,
      !creationMode,
      false,
    )
      ? null
      : 'Cover image is required.',
  };
  console.log('[ProgramEdit] Generated validation tree.', tree);
  return tree;
};

export const validateProgram = (
  collection: CollectionProgram,
  creationMode: boolean,
) => {
  // generate validation tree
  const tree = {
    name: helpers.validateString(collection.name, true)
      ? null
      : 'Program title is required.',
    color: helpers.validateString(collection.color, !creationMode)
      ? null
      : 'Color is required.',
    mediaCover: helpers.validateObject(
      collection.mediaCover,
      !creationMode,
      false,
    )
      ? null
      : 'Cover image is required.',
    duration:
      collection.duration.length &&
      collection.duration.length === 2 &&
      (typeof collection.duration[0] === 'number' ||
        typeof collection.duration[0] === 'string') &&
      typeof collection.duration[1] === 'string'
        ? null
        : creationMode
        ? null
        : 'Duration is required',
    goal: helpers.validateString(collection.goal, !creationMode)
      ? null
      : 'Goal is required',
    // tags: collection.tags?.length ? null : 'Keywords are required',
    contentStructure: helpers.validateString(
      collection.contentStructure,
      !creationMode,
    )
      ? null
      : 'Program type is required',
    // difficulty: helpers.validateString(collection.difficulty, true)
    //   ? null
    //   : 'Difficulty is required',
    // location: helpers.validateString(collection.location, true)
    //   ? null
    //   : 'Location is required',
    faq: [],
    testimonials: (() => {
      const testimonialsResult = ProgramSchema.pick({
        testimonials: true,
      }).safeParse(collection);

      const hasBrokenMedia = (collection.testimonials || []).some(
        (testimonial) => {
          if (!testimonial?.media) return false;
          const { cdn01, image } = testimonial.media;
          return !cdn01 || !image;
        },
      );

      return testimonialsResult.success && !hasBrokenMedia
        ? null
        : 'Program reviews are incorrect';
    })(),
  };
  if (collection.faq && collection.faq.length > 0) {
    for (const item of collection.faq) {
      tree.faq.push({
        question: helpers.validateString(item.question)
          ? null
          : 'Question required.',
        answer: helpers.validateString(item.answer) ? null : 'Answer required.',
      });
    }
  }
  console.log('[ProgramEdit] Generated validation tree.', tree);
  return tree;
};
